import Vue from 'vue'
Vue.directive('submitting', {
  update (el, binding) {
    if (typeof el.originalInnerHTML === 'undefined') {
      el.originalInnerHTML = el.innerHTML
      el.originalWidth = el.getBoundingClientRect().width
      el.originalHeight = el.getBoundingClientRect().height
      el.originalWidthStyle = el.style.width
      el.originalHeightStyle = el.style.height
      el.originalDisabled = el.getAttribute('disabled')
    }

    if (binding.value) {
      el.innerHTML = '<span class="btn-loader"></span>'
      el.style.width = el.originalWidth + 'px'
      el.style.height = el.originalHeight + 'px'
      el.disabled = true
    } else {
      el.innerHTML = el.originalInnerHTML
      el.style.width = el.originalWidthStyle
      el.style.height = el.originalHeightStyle

      // Don't undisabled if there is another disabled directive on the button
      if (!el.originalDisabled) {
        el.disabled = false
      }
    }
  }
})